// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d-flex {
  display: flex;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-column {
  flex-direction: column;
}

.flex-column-reverse {
  flex-direction: column-reverse;
}

.flex-row {
  flex-direction: row;
}

.flex-row-reverse {
  flex-direction: row-reverse;
}

.justify-content-start {
  justify-content: flex-start;
}

.justify-content-center {
  justify-content: center;
}

.justify-content-end {
  justify-content: flex-end;
}

.justify-content-between {
  justify-content: space-between;
}

.justify-content-around {
  justify-content: space-around;
}

.justify-content-evenly {
  justify-content: space-evenly;
}

.justify-content-baseline {
  justify-content: baseline;
}

.align-items-baseline {
  align-items: baseline;
}

.align-items-center {
  align-items: center;
}

.align-items-start {
  align-items: flex-start;
}

.align-items-end {
  align-items: flex-end;
}

.gap-initial {
  gap: 0.42rem;
}

.gap-1 {
  gap: 0.625rem;
}

.gap-2 {
  gap: 1.25rem;
}

.gap-3 {
  gap: 1.875rem;
}

.gap-4 {
  gap: 2.5rem;
}

.gap-5 {
  gap: 3.125rem;
}

.default-gap {
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/styles/display.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,8BAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,8BAAA;AACJ;;AAEA;EACI,6BAAA;AACJ;;AAEA;EACI,6BAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,SAAA;AACJ","sourcesContent":[".d-flex {\n    display: flex;\n}\n\n.flex-wrap {\n    flex-wrap: wrap;\n}\n\n.flex-column {\n    flex-direction: column;\n}\n\n.flex-column-reverse {\n    flex-direction: column-reverse;\n}\n\n.flex-row {\n    flex-direction: row;\n}\n\n.flex-row-reverse {\n    flex-direction: row-reverse;\n}\n\n.justify-content-start {\n    justify-content: flex-start;\n}\n\n.justify-content-center {\n    justify-content: center;\n}\n\n.justify-content-end {\n    justify-content: flex-end;\n}\n\n.justify-content-between {\n    justify-content: space-between;\n}\n\n.justify-content-around {\n    justify-content: space-around;\n}\n\n.justify-content-evenly {\n    justify-content: space-evenly;\n}\n\n.justify-content-baseline {\n    justify-content: baseline;\n}\n\n.align-items-baseline {\n    align-items: baseline;\n}\n\n.align-items-center {\n    align-items: center;\n}\n\n.align-items-start {\n    align-items: flex-start;\n}\n\n.align-items-end {\n    align-items: flex-end;\n}\n\n.gap-initial {\n    gap: 0.420rem;\n}\n\n.gap-1 {\n    gap: 0.625rem;\n}\n\n.gap-2 {\n    gap: 1.250rem;\n}\n\n.gap-3 {\n    gap: 1.875rem;\n}\n\n.gap-4 {\n    gap: 2.500rem;\n}\n\n.gap-5 {\n    gap: 3.125rem;\n}\n\n.default-gap {\n    gap: 16px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
